import TemplateGenerator from "./TemplateGenerator";
export default TemplateGenerator;
